export const StylePickerSkeleton = () => {
  return (
    <div className="mt-6 flex flex-col gap-3">
      <span className="h-4 w-40 bg-[#E6E6E6] rounded" />
      <div className="flex flex-row gap-3">
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
            className="flex-1 max-w-[120px] rounded-md bg-[#E6E6E6] p-3"
          >
            <div className="aspect-[3/2] rounded-md bg-[#D9D9D9]" />
            <div className="mt-3 h-4 rounded bg-[#D9D9D9]" />
          </div>
        ))}
      </div>
    </div>
  );
};
